module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal",
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.yes($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.config.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', _vm._l((_vm.sentences), function(sentence) {
    return _c('span', {
      key: sentence.id,
      style: (sentence && sentence.bold ? 'font-weight: bold' : '')
    }, [_vm._v("\n                  " + _vm._s(sentence.message) + "\n                ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.config.showNo !== false) ? _c('botao', {
    attrs: {
      "estilo": "cheio-cinza",
      "icone": "cancela-modal",
      "dismiss": "modal",
      "rotulo": _vm.config.labelNo
    },
    on: {
      "clicado": function($event) {
        return _vm.no()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "icone": "ok-modal",
      "rotulo": _vm.config.labelYes
    },
    on: {
      "clicado": function($event) {
        return _vm.yes()
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Fechar"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d98c42ec","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/index.vue
// module id = 7pmR
// module chunks = 5